import React from 'react';
import { QueryClient, QueryClientProvider, focusManager, onlineManager } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { IsProduction } from 'config/config';
import useToast from 'services/Hooks/useToast';

export const QueryProvider = ({ children }) => {
  const queryClient = new QueryClient();
  const { offlineMessage, onlineMessage } = useToast();
  queryClient.setDefaultOptions({
    queries: {
      retry: false,
      staleTime: 1000 * 60 * 5,
      refetchInterval: 1000 * 60 * 5,
    },
  });

  // Used to refetch all data when focusing on the window
  focusManager.setEventListener(handleFocus => {
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('visibilitychange', handleFocus, false);
      window.addEventListener('focus', handleFocus, false);
    }

    return () => {
      window.removeEventListener('visibilitychange', handleFocus);
      window.removeEventListener('focus', handleFocus);
    };
  });

  onlineManager.subscribe(isOnline => {
    if (!isOnline) offlineMessage();
    else onlineMessage();
  });

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {!IsProduction && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
};
